/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CourseRequestGroup } from '../../models/course-request-group';
import { RequestResult } from '../../models/request-result';

export interface ApiRequestCourseSaveBillingPost$Params {
      body?: CourseRequestGroup
}

export function apiRequestCourseSaveBillingPost(http: HttpClient, rootUrl: string, params?: ApiRequestCourseSaveBillingPost$Params, context?: HttpContext): Observable<StrictHttpResponse<RequestResult>> {
  const rb = new RequestBuilder(rootUrl, apiRequestCourseSaveBillingPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RequestResult>;
    })
  );
}

apiRequestCourseSaveBillingPost.PATH = '/api/Request/Course/SaveBilling';
